/* jQuery logic */
jQuery(function ($) {
  // Open the modal
  $('#size-guide-btn').on('click', function (e) {
    e.preventDefault();             // keep links from jumping
    $('#size-guide-modal').addClass('active');
    $('body').addClass('no-scroll'); // optional: lock scroll
  });

  // Close via the close button
  $('#size-guide-modal .close').on('click', function () {
    $('#size-guide-modal').removeClass('active');
    $('body').removeClass('no-scroll');
  });

  // Close by clicking outside the inner content (optional)
  $('#size-guide-modal').on('click', function (e) {
    if (e.target === this) {        // only if backdrop itself is clicked
      $(this).removeClass('active');
      $('body').removeClass('no-scroll');
    }
  });

  // ESC key closes the modal (optional quality of life)
  $(document).on('keyup', function (e) {
    if (e.key === 'Escape') {
      $('#size-guide-modal').removeClass('active');
      $('body').removeClass('no-scroll');
    }
  });




$(window).on('scroll', function() {
  if ($(this).scrollTop() > 100) {
    $('.header').addClass('scrolled-cstm');
  } else {
    $('.header').removeClass('scrolled-cstm');
  }
});




// Run only on desktop
  if (window.innerWidth >= 768) {
    const $slider = $('.productView-nav');

    // Check if Slick is initialized
    if ($slider.hasClass('slick-initialized')) {
      insertSlickCounter($slider);
    } else {
      // Wait for Slick to initialize
      const checkSlickInterval = setInterval(function () {
        if ($slider.hasClass('slick-initialized')) {
          clearInterval(checkSlickInterval);
          insertSlickCounter($slider);
        }
      }, 100);
    }

    function insertSlickCounter($slider) {
      // Prevent duplicate counter
      if ($slider.find('.slick-counter').length > 0) return;

      const totalSlides = $slider.find('.slick-slide:not(.slick-cloned)').length;

      // Append counter markup
      $slider.append(`
        <div class="slick-counter">
          <span class="slick-counter--current">1</span>
          <span aria-hidden="true">/</span>
          <span class="slick-counter--total">${totalSlides}</span>
        </div>
      `);

      // Update counter on slide change
      $slider.on('afterChange', function (event, slick, currentSlide) {
        $slider.find('.slick-counter--current').text(currentSlide + 1);
      });
    }
  }

  

$('.productView-variants .form__label').each(function () {
    var text = $(this).text().trim();
    if (text === 'Color') {
      $(this).text('COLOUR');
    }
    // If "Color" is part of a longer string
    else if (text.includes('Color')) {
      $(this).text(text.replace(/Color/g, 'COLOUR'));
    }
  });






  
});






